import { defaultMultipleSelectProps, ValueContainer } from "components/shared/select";
import { gasStationVisitStatuses } from "helpers/enums";
import { paths } from "helpers/paths";
import { NumericColumnFilter, reportFilterWrapper, SelectColumnFilter } from "helpers/reactTable";
import { columnName, formatValue, typeSpecificProps } from "helpers/reports";
import React from "react";
import CommonReport from "./commonReport";

export default class RefuelingsReport extends CommonReport {
    setTableState = (data) => {
        const params = {};
        const newDeviationVolumeFilter = data.filters.find((item) => item.id === "deviationVolume");
        const newDeviationVolumeValue = newDeviationVolumeFilter?.value?.value;
        const oldDeviationVolumeFilter = this.state.filters.find((item) => item.id === "deviationVolume");
        const oldDeviationVolumeValue = oldDeviationVolumeFilter?.value?.value;
        if (
            (oldDeviationVolumeValue?.key !== newDeviationVolumeValue?.key &&
                (oldDeviationVolumeValue?.value || newDeviationVolumeValue?.value)) ||
            oldDeviationVolumeValue?.value !== newDeviationVolumeValue?.value
        ) {
            params.deviationVolume = newDeviationVolumeValue;
        }

        const newVisitStatusFilter = data.filters.find((item) => item.id === "visitStatusDisplayName");
        const newVisitStatusValue = newVisitStatusFilter?.value?.value;
        const oldVisitStatusFilter = this.state.filters.find((item) => item.id === "visitStatusDisplayName");
        const oldVisitStatusValue = oldVisitStatusFilter?.value?.value;
        if (oldVisitStatusValue !== newVisitStatusValue) {
            params.visitStatus = newVisitStatusValue;
        }

        if (Object.keys(params).length > 0) {
            this.props.getItem(params);
        }
        this.setState(data);
    };

    typeSpecificProps = (column) => {
        if (column.propertyName === "DeviationVolume") {
            return {
                filterable: true,
                filter: (rows) => rows,
                Filter: reportFilterWrapper(NumericColumnFilter),
            };
        } else if (column.propertyName === "VisitStatusDisplayName") {
            return {
                filterable: true,
                Filter: reportFilterWrapper((props) => (
                    <SelectColumnFilter
                        {...props}
                        selectProps={{
                            inputProps: { name: "visitStatus" },
                            options: gasStationVisitStatuses,
                            ...defaultMultipleSelectProps,
                            components: { ValueContainer },
                        }}
                    />
                )),
                filter: (rows) => rows,
            };
        } else {
            return typeSpecificProps(column);
        }
    };

    openModal = (rowData) => {
        this.props.modal({
            name: "modalMap",
            title: "Адрес АЗС",
            windowMod: "wide modal--vh-75",
            data: { ...rowData, dataType: "refueling" },
        });
    };

    cellProps = (column) => {
        return {
            Header: column.label,
            accessor: columnName(column),
            show: !column.isAdditionalColumn,
            Cell: (props) => {
                switch (props.column.id) {
                    case "bidId":
                        return (
                            <a
                                data-bidid={props.value}
                                href={paths.bidShow("bid", props.value)}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                {props.value}
                            </a>
                        );
                    case "address":
                        return (
                            <div className="link" onClick={this.openModal.bind(this, props.row.original)}>
                                {props.value}
                            </div>
                        );
                    default:
                        return <div className="long-text">{formatValue(props.value, column.clrType)}</div>;
                }
            },
            Footer: () => this.footerVal(column),
            ...this.typeSpecificProps(column),
        };
    };
}
